import React from 'react';

export type UrlOpener = (url: string) => void;
interface PluginContextData {
    openUrl?: UrlOpener;
    tagConversation?: (tagId: string) => void;
}

export const PluginContext = React.createContext<PluginContextData>({});
